import { Form, Modal, Spinner } from "react-bootstrap";

const AddFormFieldLibrary = ({
  Show,
  Hide,
  fieldData,
  setCategoryId,
  categoryId,
  formFieldLibraryList,
  addFiledButtonLoader,
  addNewFieldsGlobalFormFieldLibrary,
}) => {
  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add {fieldData?.fieldName} Field in Librray</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="fw-bold mb-1">
              Library{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setCategoryId(e.target.value)}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={categoryId === ""} value="">
                Select Library
              </option>
              {formFieldLibraryList?.map((item, index) => (
                <option
                  key={index}
                  selected={categoryId === item?.categoryId}
                  value={item?.categoryId}
                >
                  {item?.categoryName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="m-0 p-1 px-3 bg-light">
          <div className="text-end">
            <button
              disabled={!categoryId || addFiledButtonLoader}
              onClick={addNewFieldsGlobalFormFieldLibrary}
              className={`updateProfile`}
            >
              {addFiledButtonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm"/> Adding...
                </div>
              ) : (
                "Add Field"
              )}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddFormFieldLibrary;
